<div class="vehicle-details-params-tab">

    <div class="basic-params">
        <span class="last-update-title">{{'update'|translate}}: <span class="bold">{{lastUpdated|statusTimeFormat}}</span></span>

        <!-- {{'vehicle-details-tacho-tab.last-measurement' | translate}} {{lastUpdated | statusTimeFormat}} {{'labels.ago' | translate}} -->

        <div class="basic-params__list">
            <div class="basic-params__list__item speed">
                <div *ngIf="maxSpeedStreet" class="max-speed">
                    <span>
                        {{ maxSpeedStreet }}
                    </span>
                </div>
                <div class="param-header"></div>
                <div class="param-wrapper">
                    <span class="param-value km">
                        <span class="speed">
                            {{ (speed && speed?.LV?.V) ? (speed.LV.V | number:'1.0-0') : '0' }}
                        </span>
                    </span>
                </div>
                <span class="param-name">km/h</span>
            </div>
            <div class="basic-params__list__item">
                <div class="param-header"></div>
                <div class="param-wrapper">
                    <span class="param-value">
                        {{ (voltage?.LV?.V | number : '1.0-1') || '-' }} V
                    </span>
                </div>
                <span class="param-name">
                    {{'vehicle-indicator.voltage'|translate}}
                </span>
            </div>
            <div class="basic-params__list__item gsm">
                <p-progressBar class="param-header" [showValue]="false" [value]="gsmLevelPercent"></p-progressBar>
                <div class="param-wrapper">
                    <span class="param-value">
                        {{ gsm?.LV?.V || '-' }}
                    </span>
                </div>
                <span class="param-name">GSM</span>
            </div>
            <div class="basic-params__list__item gps">
                <p-progressBar class="param-header" [showValue]="false" [value]="gpsLevelPercent"></p-progressBar>
                <div class="param-wrapper">
                    <span class="param-value">
                        {{ gps?.LV?.V || '-' }}
                    </span>
                </div>
                <span class="param-name">GPS</span>
            </div>
        </div>
    </div>

    <div class="driver-wrapper">
        <div class="driver-wrapper__avatar">
            <span>
                <ng-container *ngIf="_vehicle.LastDriver">
                    {{ _vehicle.LastDriver?.FN?.slice(0,1) }}{{ _vehicle.LastDriver?.LN?.slice(0,1) }}
                </ng-container>
                <ng-container *ngIf="!_vehicle.LastDriver">BD</ng-container>
            </span>
        </div>
        <div class="column-right">
            <div class="driver-wrapper__details">
                <span class="drive-name">
                    <ng-container *ngIf="_vehicle.LastDriver">{{ _vehicle.LastDriver?.FN }} {{ _vehicle.LastDriver?.LN }}</ng-container>
                    <ng-container *ngIf="!_vehicle.LastDriver">
                        {{'noDriverData'|translate}}
                    </ng-container>
                </span>
                <tk-vehicle-location [location]="_vehicle.LL" class="driver-location"></tk-vehicle-location>
            </div>
            <div class="driver-wrapper__actions">
                <!-- <button class="item">
                    <i class="pi pi-share-alt" style="font-size: 10px; margin-right: 2px;"></i>
                </button> -->
                <button (click)="openGoogleMaps()" class="action">
                    <img src="/assets/images/map/i-external-map-white.svg" alt="">
                </button>
                <button (click)="copyCoords()" class="action">
                    <img class="copy" src="/assets/images/shared/i-copy-black.svg" alt="">
                </button>
            </div>
        </div>
    </div>

    <div *ngIf="fuelState?.LV?.V && maxFuelValue" class="fuel-data-wrapper">
        <div class="fuel-data">
            <div class="column-left">
                <span class="title">
                    {{'labels.fuel'|translate}}
                </span>
                <span class="value">
                    {{ (fuelState?.LV?.V | number: '1.1-1') }} l
                </span>
            </div>
            <div *ngIf="maxFuelValue?.Capacity" class="column-right">
                <img class="fuel-icon" src="/assets/images/vehicles/fuel.svg" alt="">
                <p-progressBar
                    [showValue]="false"
                    [value]="fuelState?.LV.V | tankFillPercentage : maxFuelValue.Capacity"
                ></p-progressBar>
            </div>
        </div>
    </div>

    <div class="params-list">
        <div *ngFor="let param of analogParams" class="params-list__item">
            <span class="params-list__item__title"  [title]="param.Nm | translateByText">
                {{ param.Nm | translateByText }}
            </span>
            <span class="params-list__value">
                <tk-vehicle-control-indicator-value [param]="param"></tk-vehicle-control-indicator-value>
            </span>
        </div>
    </div>

    <div class="params">
        <!-- binarne -->
        <div *ngIf="binaryParams.length > 0" class="binary">
            <!-- <span class="title">{{'vehicle-details-params-tab.binary' | translate}}</span> -->
            <div *ngFor="let param of binaryParams" class="param">
                <tk-vehicle-control-indicator-value [param]="param"></tk-vehicle-control-indicator-value>
                <span class="name" [title]="param.Nm | translateByText">{{ param.Nm | translateByText }}</span>
            </div>
        </div>
    </div>

    <div class="services-data">
        <div class="services-data__item">
            <div class="services-data__item__details">
                <div class="services-data__item__details__column-left">
                    <span class="title">
                        {{'deviceId'|translate}}
                    </span>

                    <app-network-type-marker [type]="_vehicle.DN"></app-network-type-marker>
                </div>
                <span
                    (click)="copyValue(_vehicle?.SN)"
                    [pTooltip]="'copy'|translate"
                    tooltipPosition="top"
                    tooltipStyleClass="tooltip-pinned"
                    class="value bg"
                >
                    {{_vehicle?.SN}}
                </span>
            </div>

            <!-- <app-network-warrning
                *ngIf="languageService.isPolishLanguage && riskCategory === RISK_CATEGORY.AtRiskAbroad"
                [risk]="riskCategory"
                class="network-warning"
            ></app-network-warrning> -->
        </div>

        <div class="services-data__item">
            <div class="services-data__item__details">
                <div class="services-data__item__details__column-left">
                    <span class="title">
                        {{ 'create-account.id' | translate }}
                    </span>
                </div>
                <span
                    (click)="copyValue(_vehicle?.SentGeoId)"
                    [pTooltip]="'copy'|translate"
                    tooltipPosition="top"
                    tooltipStyleClass="tooltip-pinned"
                    class="value"
                >
                    {{ _vehicle?.SentGeoId }}
                </span>
            </div>
        </div>
    </div>

</div>
